module.exports = __webpack_public_path__ + "static/iterations-6d927b74b4c2c3c3651c2b9adfdf7d82.png";